<template>
  <main class="w-full">
    <slot />
  </main>
</template>

<script>
export default {
  props: ["loggedIn"],
  created() {
    if (this.loggedIn) {
      this.$router.push({ name: "Admin" });
    }
  },
};
</script>

<style lang="scss" scoped></style>
